import BaseState, { type IParams, type ITitleClass } from './base'
import { type IEquity } from '~/api/interface/rights'
import { USER_LEVEL_KEY } from '~/api/interface'
import { USER_ADMIN } from '~/constants'

/** 团队体验版 */
export default class Rights15 extends BaseState {
  // eslint-disable-next-line no-useless-constructor
  constructor(state: IParams) {
    super(state)
  }

  TitleView = defineComponent({
    name: 'TitleView15',
    props: {
      titleClass: {
        type: Object as PropType<ITitleClass>,
        required: true,
      },
      rights: {
        type: Object as PropType<IEquity>,
        required: true,
      },
      hovered: {
        type: Boolean,
        default() {
          return false
        },
      },
    },
    setup(props) {
      const { titleClass, rights } = props
      const { $t } = useNuxtApp()

      return () => (
        <>
          <div>
            <div class="h-[50px]"></div>
            <div class={titleClass.name}>{rights.rights_name}</div>
            <div class={titleClass.number}>
              {$t('rightsaccountcount-ren-shi-yong')}
            </div>
          </div>
          <div class={titleClass.feature}>{rights.subject}</div>
        </>
      )
    },
  })

  get PriceView() {
    const { $t } = useNuxtApp()

    return (
      <div class="py-[24px] text-center text-[24px] leading-[32px] font-bold semibold">
        {$t('mian-fei')}
      </div>
    )
  }

  get ButtonView() {
    const { $t } = useNuxtApp()
    if (this.hasManaged) {
      return this.getButton({
        ghost: true,
        text: $t('yi-jing-shen-qing-ti-yan'),
        disabled: true,
      })
    }
    return this.getButton({
      ghost: true,
      text: $t('li-ji-ti-yan'),
      cb: this.toCreateRights15.bind(this),
    })
  }

  get StickyButtonView() {
    const { $t } = useNuxtApp()

    if (this.hasManaged) {
      return this.getButton({
        normalSize: true,
        ghost: true,
        text: $t('yi-jing-shen-qing-ti-yan'),
        disabled: true,
      })
    }
    return this.getButton({
      normalSize: true,
      ghost: true,
      text: $t('li-ji-ti-yan'),
      cb: this.toCreateRights15.bind(this),
    })
  }

  get hasManaged() {
    // @ts-ignore
    return this.state.accountList.find(
      (a) =>
        a.rights_type === USER_LEVEL_KEY.TEAM_TASTE &&
        a.permission >= USER_ADMIN.ORG_ADMIN_USER
    )
  }
}
